import resources from '@/crud/index/index'

export default {
  mixins: [resources],

  resourcePath: '/v1/professional/schedules/scheduled'
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/resources.js